/**
 * KAN-721: превью материала оператора: миниатюра для картинки, иконка файла
 * для документа (PDF, Excel, Word).
 */
import { FileText } from 'lucide-react';
import type { InstructionAttachment } from '@/services/api/instructionAttachments';
import { useApiFileSrc } from '@/hooks/useApiFileSrc';
import { isImageMaterial } from './materialFiles';

interface MaterialPreviewProps {
  item: InstructionAttachment;
  /** Размер в tailwind-классах, по умолчанию 16 (4rem). */
  className?: string;
}

export function MaterialPreview({
  item,
  className = 'h-16 w-16',
}: MaterialPreviewProps): JSX.Element {
  // KAN-770: файл отдаёт API с токеном (MEDIA в проде не раздаётся), S3-ссылка - как есть.
  const src = useApiFileSrc(isImageMaterial(item) ? item.file_url : '');
  if (isImageMaterial(item)) {
    if (!src) {
      return <div className={`${className} flex-shrink-0 rounded bg-muted`} />;
    }
    return (
      <img
        src={src}
        alt={item.title}
        className={`${className} flex-shrink-0 rounded object-cover bg-muted`}
      />
    );
  }
  return (
    <div
      data-testid={`material-file-icon-${item.id}`}
      className={`${className} flex flex-shrink-0 items-center justify-center rounded bg-muted`}>
      <FileText aria-hidden="true" className="h-1/2 w-1/2 text-muted-foreground" />
    </div>
  );
}
